<template>
  <form @submit.prevent="save" lazy-validation>
    <v-dialog v-model="showModal" scrollable persistent max-width="500px" v-if="contact">
      <v-card>
        <v-card-title>
          <span class="headline">Edit contact</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="contact.name"
                  label="Name"
                  v-validate="'required|max:75'"
                  :error-messages="errors.collect('name')"
                  data-vv-name="name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="contact.email"
                  label="E-mail"
                  v-validate="'required|email'"
                  :error-messages="errors.collect('email')"
                  data-vv-name="email"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="contact.position"
                  label="Segmentation 1"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="contact.seniority"
                  label="Segmentation 2"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="contact.priority"
                  label="Segmentation 3"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="contact.company"
                  label="Segmentation 4"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="contact.country"
                  label="Segmentation 5"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="contact.segmentation"
                  label="Segmentation 6"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="contact.segmentation2"
                  label="Segmentation 7"
                ></v-text-field>
              </v-flex>
               <v-flex xs12 sm6>
                <v-text-field
                  v-model="contact.tag"
                  label="Segmentation 8"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="closeModal">Cancel</v-btn>
          <v-btn color="primary" type="submit" @click="save">Save</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </form>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    contactId: {
      type: String,
      default: null
    }
  },
  data: () => {
    return {
      contact: null
    };
  },
  mounted () {
    this.editContact();
  },
  methods: {
    ...mapActions(['setSnackbar', 'setLoading']),
    save () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.setLoading(true);
          let payload = {
            id: this.contact.id,
            name: this.contact.name,
            email: this.contact.email,
            position: this.contact.position,
            seniority: this.contact.seniority,
            priority: this.contact.priority,
            country: this.contact.country,
            segmentation: this.contact.segmentation,
            segmentation2: this.contact.segmentation2,
            company: this.contact.company,
            tag: this.contact.tag
          };
          let url = `/contacts/${this.contactId}/update`;
          window.axios.put(url, payload).then(response => {
            this.setLoading(false);
            this.$emit('update-contact', this.contact);
            this.setSnackbar({
              show: true,
              color: 'success',
              text: 'Contact updated.'
            });
            this.closeModal();
            
          }).catch(error => {
            this.setLoading(false);
          });
        } else {
          this.setLoading(false);
          this.setSnackbar({
            show: true,
            color: 'info',
            text: 'Check the form, please.'
          });
        }
      });
    },
    editContact () {
      const url = '/contacts/' + this.contactId + '/edit';
      window.axios.get(url).then((response) => {
        this.contact = response.data.data;
      }).catch((error) => {
        console.log(error);
      });
    
    },
    closeModal () {
      this.$emit('close-modal-edit-contact');
      this.contact = null;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/client/contacts/components/modals/EditContact.vue